module.exports = __webpack_public_path__ + "static/media/img8.afbe9d4b.PNG";